// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-layout {
  height: 10vh;
  display: grid;
  grid-template-columns: 20% 80%;
  background-color: #A5AAB1;
  color: white;
  align-items: center;
}

.gc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 40px;
  background: #fff;
  margin-bottom: 24px;
}
.gc-header .gc-breadcrumb ul {
  list-style: none;
}
.gc-header .gc-breadcrumb ul li {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  color: #4B5563;
}
.gc-header .gc-breadcrumb ul li span {
  padding: 0 7px;
}
.gc-header .gc-breadcrumb ul li a {
  color: #2B3990;
}
.gc-header .gc-notification {
  position: relative;
  margin-right: 27px;
}
.gc-header .gc-notification span {
  width: 14px;
  height: 14px;
  color: #fff;
  font-size: 7px;
  background: #2B3990;
  position: absolute;
  top: -5px;
  right: -3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.gc-header .gc-agency-avatar {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.gc-header .gc-agency-avatar .agency-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  flex: 0 0 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-header .gc-agency-avatar .agency-dropdown {
  position: absolute;
  top: 0;
  right: 0;
  background: #fff;
  width: 240px;
  border: 5px;
  z-index: 9;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px 10px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul {
  list-style: none;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li {
  border-bottom: 1px solid #FAFAFA;
  cursor: pointer;
  padding: 10px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  min-height: 40px;
  position: relative;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li:last-child {
  border-bottom: none;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-icon {
  width: 20px;
  display: inline-block;
  flex: 0 0 20px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li span img {
  display: block;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-roll-dropdown {
  position: absolute;
  right: 100%;
  top: 0;
  width: 240px;
  background: #fff;
  display: none;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-roll-dropdown li a span::before {
  content: "";
  width: 5px;
  height: 5px;
  background: #1C75BC;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-block;
  vertical-align: middle;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .agency-roll-dropdown li i {
  color: #10B981;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li:hover, .gc-header .gc-agency-avatar .agency-dropdown ul li.active {
  background: #ECF0F5;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li:hover .agency-roll-dropdown {
  display: block;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #344054;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li a div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .gc-agency-name {
  font-size: 14px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li p.gc-agency-handle {
  font-size: 12px;
}
.gc-header .gc-agency-avatar .agency-dropdown ul li .gc-logout-btn a {
  color: #FF3C3C;
}
.hover-cursor {
  cursor: pointer;
}

.m-l-10 {
  margin-left: 10px;
}

.w-70 {
  width: 70%;
}

.align-right-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.align-center {
  display: flex;
  align-items: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
